interface QuizQuestion {
  id: string;
  question: string;
  options: string[];
  correctAnswer: number;
  explanation: string;
}

export const bigOQuizQuestions: QuizQuestion[] = [
  {
    id: 'bigo-1',
    question: `What is the time complexity of the following code snippet?
\`\`\`python
for i in range(n):
    for j in range(n):
        print(i * j)
\`\`\``,
    options: [
      'O(n)',
      'O(n²)',
      'O(log n)',
      'O(n log n)'
    ],
    correctAnswer: 1,
    explanation: 'The code has two nested loops, each running n times. For each iteration of the outer loop, the inner loop runs n times, resulting in n * n = n² operations.'
  },
  {
    id: 'bigo-2',
    question: 'Which of the following operations has a constant time complexity O(1)?',
    options: [
      'Finding an element in an unsorted array',
      'Accessing an element by index in an array',
      'Finding the minimum element in an unsorted array',
      'Inserting an element at the beginning of an array'
    ],
    correctAnswer: 1,
    explanation: 'Accessing an element by index in an array is a constant time operation O(1) because it directly computes the memory location using the index, regardless of array size.'
  },
  {
    id: 'bigo-3',
    question: `What is the space complexity of the following recursive function?
\`\`\`python
def factorial(n):
    if n <= 1:
        return 1
    return n * factorial(n - 1)
\`\`\``,
    options: [
      'O(1)',
      'O(n)',
      'O(n²)',
      'O(log n)'
    ],
    correctAnswer: 1,
    explanation: 'The recursive factorial function creates a new stack frame for each recursive call. Since it makes n recursive calls before reaching the base case, it uses O(n) space on the call stack.'
  },
  {
    id: 'bigo-4',
    question: 'Which sorting algorithm has the best average-case time complexity?',
    options: [
      'Bubble Sort - O(n²)',
      'Quick Sort - O(n log n)',
      'Insertion Sort - O(n²)',
      'Selection Sort - O(n²)'
    ],
    correctAnswer: 1,
    explanation: 'Quick Sort has an average-case time complexity of O(n log n), which is better than the O(n²) complexity of bubble, insertion, and selection sort. While merge sort also has O(n log n), quick sort generally performs better in practice due to better cache utilization.'
  },
  {
    id: 'bigo-5',
    question: 'What is the time complexity of binary search on a sorted array?',
    options: [
      'O(n)',
      'O(n²)',
      'O(log n)',
      'O(1)'
    ],
    correctAnswer: 2,
    explanation: 'Binary search repeatedly divides the search interval in half. Since the array size is reduced by half in each step, it results in a logarithmic time complexity of O(log n).'
  }
];
